export default __webpack_public_path__ + "static/media/GSHv4WVaUAYNZlE.f6a30c36.jpg";